<template>
  <div class="vote-detail-container">
    <top-banner :data="data"></top-banner>
    <div class="vote-option-detail">
      <div class="vote-detail-header">
        <div class="opa-icon">{{ data.inner_id }}号</div>
        <h3 class="option-title">{{ data.title }}</h3>
        <p class="option-count" v-if="showAllTickets()">{{ showTextLabel }}{{ data.count }}</p>
      </div>
      <div class="vote-detail-body">
        <img v-if="data.pic && data.option_type == '1'" class="option-pic" :src="`${data.pic}`" alt />
        <div class="desc-box" v-html="data.des || `暂无描述`"></div>
      </div>
      <div class="vote-detail-footer">
        <div class="back" @click="goBack"></div>
        <SingleVoteButton v-if="data.type == 1" :disabled="isEnded" :voteText="voteText" :index="detailParams.index"
          :activeTab="data.activeTab" @single-vote="handleDetailSingleClick">
        </SingleVoteButton>
        <div class="btn-card" @click="handleShareCard" v-if="!isPC"></div>
      </div>
      <van-popup v-model="popShow" position="center" closeable close-icon @click.native="closePop">
        <ShareCard :data="shareCardData" :option="data.index" @close-pop="closePop"></ShareCard>
      </van-popup>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from 'vant';
import { isPC } from "../utils/utils";
import TopBanner from "../components/TopBanner";
import SingleVoteButton from "./SingleVoteButton";
import ShareCard from "./ShareCard";

export default {
  name: "OptionDetail",
  props: {
    detailParams: {
      type: Object,
      default: {}
    },
    isEnded: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      shareCardData: {},
      voteText: "",
      showText: "",
      showTextLabel: "",
      popShow: false,
    };
  },
  components: {
    TopBanner,
    SingleVoteButton,
    ShareCard
  },
  watch: {},
  computed: {
    data() {
      return this.detailParams
    },
    isPC() {
      return isPC()
    }
  },
  methods: {
    init() {
      // console.log("选项详情入参 this.data", this.data)
      this.voteText = this.$store.state.voteText;
      this.showTextLabel = this.voteText == "投票" ? "票数：" : "点赞数：";
      this.showText = this.voteText == "投票" ? "票" : "赞";
      this.shareCardData = Object.assign(this.shareCardData, this.data);
      if (this.data.option_type == '2') {
        this.shareCardData.pic = this.$store.state.voteInfo.cover_pic
      }
    },
    goBack() {
      this.$emit("close-pop", false);
    },
    handleImgClick(src) {
      ImagePreview({
        images: [src],
        showIndex: true,
        loop: false,
        startPosition: 0
      });
      this.$emit("close-pop");
    },
    handleShareCard() {
      this.popShow = true
    },
    closePop() {
      this.popShow = false;
    },
    handleDetailSingleClick(index, vote_number) {
      this.$emit("single-vote", index, vote_number);
      this.closePop();
    },
    showAllTickets() {
      if (this.$utils.getUrlParams("id") == 'NTAxOjU1Y2Jh' || this.$utils.getUrlParams("id") == 'NDcxNTphNWEyNQ') {
        return false
      }
      return true
    }
  },
  mounted() {
    this.init()
  },
};
</script>

<style scoped lang="less">
.vote-detail-container {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 99;
  background: #f6f6f6;
  overflow-y: scroll;

  .van-popup {
    width: 100%;
    height: 100%;
    background: transparent;
  }

  .vote-option-detail {
    background: #fff;
    padding: 0 0.25rem 1.8rem;
    min-height: 3.35rem;
    text-align: justify;

    .vote-detail-header {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .opa-icon {
        position: static;
      }

      .option-title {
        font-size: 0.3rem;
        line-height: 0.4rem;
        height: 1.5rem;
        overflow: hidden;
        color: #333;
        margin-top: 0;
        display: flex;
        align-items: center;
        font-weight: bold;
      }

      .option-count {
        font-size: 0.34rem;
        line-height: 0.52rem;
        height: 0.52rem;
        overflow: hidden;
        color: #333;
        text-align: center;
      }

    }

    .vote-detail-body {
      .option-pic {
        max-width: 7.5rem;
        max-height: 100%;
      }

      img {
        max-width: 100% !important;
      }

      .desc-box {
        word-break: break-all;
        font-size: 0.32rem;
        line-height: 0.52rem;
        color: #666;
        padding: 0.5rem 0 0.75rem;
        background: #fff;

        img {
          max-width: 100% !important;
        }
      }
    }

    .vote-detail-footer {
      width: 100%;
      height: 1.8rem;
      position: fixed;
      left: 0;
      bottom: 0;
      display: flex;
      justify-content: space-around;
      align-items: center;
      background: #fff;
      padding: 0 .3rem;

      .option-btn-group {
        margin-top: 0;
      }

      .back {
        width: .64rem;
        height: .64rem;
        background: url(../assets/images/icon-home.png) no-repeat;
        background-size: 100% 100%;
      }

      .btn-card {
        width: .64rem;
        height: .64rem;
        background: url(../assets/images/icon-share.png) no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}
</style>